import { combineReducers, createStore, applyMiddleware } from 'redux';
import allProducts from './Reducer/productreducer';

const store = combineReducers({
    allProducts: allProducts
})

export default store;
